import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTrip } from "redux/actions/UserTrip";
import { getRevenueExport, getRevenueMatrix } from "redux/actions/UserReport";
import { getServiceCity } from "redux/actions/UserServiceCity";
import { dateFormate, handlePermissions } from "utils/utils";
import ReportsTab from "./ReportsTab";
import bookingCount from "assets/images/bookingCount.svg"
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import { requestBookingReportApi } from "services/BookingReportService";
import { toast } from "react-toastify";
import { tripBookingReportFetchApi, tripBookingReportExportApi } from "services/ReportService";

function Reports() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = localStorage.getItem('role')
  const [value, setValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateFrom, setDateFrom] = useState(dateFormate(new Date(),"MM/DD/YYYY"));
  const [dateTo, setDateTo] = useState(dateFormate(new Date(), "MM/DD/YYYY"));
  const [isRequestingReport, setIsRequestingReport] = useState(false);

  // const tableData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const [tableData, setTableData] = useState([]);
  const [isExporting, setIsExporting] = useState(false);


  const loader = useSelector((state) => state?.userTrip?.loading);
  const bookingData = useSelector(
    (state) => state?.userRevenueMatrix?.userRevenueMatrix?.data) ||
    {};
  const isLoadingRideAnalytic = useSelector(
    (state) => state?.userRevenueMatrix.loading
  );
  const locationData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const userProfileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const Location = locationData;
  const [locValue, setLocValue] = useState(locationData);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);
   const roleAndPermissions = useSelector(
      (state) => state?.getRolesAndPermissions?.rolesAndPermissions
    );

  let filterData = {
    id: "",
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    pageSize: rowsPerPage,
    type: value,
    status: "",
    tabValue:'booking',
    location: selectedLocation?.id,
  };

  let dutyType = {
    "Ride" : '1',
    "Airport": '4',
    "Rental": '3',
    "OutStation": '9'
  }

  let filterDateRange = {
    dateFrom:dateFrom,
    dateTo:dateTo,
    location:userProfileData?.Company?.ServiceCity?.id || ''
  }

  const titleData = {
    barTitle: "Booking Split",
    doughnutTitle: "Total  No. of Booking ",
  };

  const getFilterData = () => ({
    id: "",
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    pageSize: rowsPerPage,
    type: value && value != "" ? dutyType[value] : null,
    status: "",
    tabValue: 'booking',
    location: selectedLocation?.id || locValue?.id,
  });

  const fetchData = async (filterData) => {
      
      try {
        const response = await tripBookingReportFetchApi(filterData);
        if (response.success) {
          
          setTableData(response?.data || []);
          
        }
      } catch (error) {
        setTableData([]);
        
      }
    };

  useEffect(() => {
    if (userProfileData?.Company?.ServiceCity?.id) {
      setLocValue({
        id: userProfileData?.Company?.ServiceCity?.id,
        name: userProfileData?.Company?.ServiceCity?.name,
      });
    }
  }, [userProfileData?.Company?.ServiceCity?.id]);

  const handleChange = (newValue) => {
    filterData = {...filterData, type: newValue }
    const filterData2 = {
      ...getFilterData(),
      type: dutyType[newValue]
    };
    fetchData(filterData2)
    
    dispatch(getRevenueMatrix(filterData));
    setValue(newValue);
  };

  useEffect(() => {
    const filterData = {
      ...getFilterData(),
      type: "1",
      location: selectedLocation?.id || locValue?.id
    };
    fetchData(filterData);
    dispatch(getRevenueMatrix({ ...filterData, type: "ride",location:selectedLocation?.id }));
    dispatch(getServiceCity());
  }, [selectedLocation?.id]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
    const filterData = {
      ...getFilterData(),
      page: newPage
    };
    fetchData(filterData);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    const newRowsPerPage = parseInt(event.target.value);
    setPage(0);
    const filterData = {
      ...getFilterData(),
      page: 0,
      pageSize: newRowsPerPage
    };
    fetchData(filterData);
  };

  const onClickTableVendor = (data) => {
    navigate("/rideTrack/details", {
      state: {
        id: data?.id,
        status: data?.status,
        customer: data?.customerName,
        driver: data?.driverName,
        value,
        tripId: data?.tripId,
      },
    });
  };

  const onSelectDateRange = (newValue) => {
    let newDateFrom = '';
    let newDateTo = '';
    if(newValue === null){
      setDateFrom('')
      setDateTo('')
      filterData = {...filterData, 
        dateFrom:'',
        dateTo:''
      }
    }else{
      setDateFrom(dateFormate(newValue[0], "MM/DD/YYYY"))
      setDateTo(dateFormate(newValue[1], "MM/DD/YYYY"))
      newDateFrom = dateFormate(newValue[0], "YYYY-MM-DD");
      newDateTo = dateFormate(newValue[1], "YYYY-MM-DD");
      filterData = {...filterData, 
        dateFrom:dateFormate(newValue[0], "MM/DD/YYYY"),
        dateTo:dateFormate(newValue[1], "MM/DD/YYYY")
      }
    }
    const filterData2 = {
      ...getFilterData(),
      dateFrom: newDateFrom,
      dateTo: newDateTo
    };
    fetchData(filterData2);
    dispatch(getRevenueMatrix(filterData));
  }

   const onExport = async () => {
      setIsExporting(true);
      try {
        const exportFilter = {
          ...getFilterData(),
          export: true,
        };
        const response = await tripBookingReportExportApi(exportFilter);
        if (response.success) {
          // Handle successful export - maybe show a toast message
          toast.success(response.data?.message || "Trip Booking report generation started. You will receive an email once ready.");
        }
      } catch (error) {
        toast.error("Failed to export trip booking report. Please try again later.");
      } finally {
        setIsExporting(false);
      }
    };

  const onInputChange = (data) => {
    setLocValue(data);
   // setLocId(data?.id);
  // console.log( 'Location changed Reports onInputChange:', data?.id);
    const filterData = {
      ...getFilterData(),
      location: data?.id
    };
    fetchData(filterData);
    dispatch(getRevenueMatrix({ ...filterData, location: data?.id }));
  };


  const reportRoleEnum =
    roleAndPermissionEnum.reports;

  const accessForall = handlePermissions(
    roleAndPermissions,
    reportRoleEnum.moduleKey,
    { defaultAllAccess: reportRoleEnum?.subModules?.booking?.all }
  );

  const accessForDownload = handlePermissions(
    roleAndPermissions,
    reportRoleEnum.moduleKey,
    { customAccess: reportRoleEnum?.subModules?.booking?.download }
  );

  const hasViewMoreIcon = (accessForall || accessForDownload);

const onRequestReport = async (format) => {
    setIsRequestingReport(true);
  try {
    const payload = {
      startDate: dateFrom,
      endDate: dateTo,
      reportType: "TRIP_BOOKING",
      reportFormate: format,
      location: selectedLocation?.id || locValue?.id,
      type: value
    };
    const response = await requestBookingReportApi(payload);
    if (response.success) {
      toast.success("Report request submitted successfully");
      navigate("/report-generate");
    } else {
      toast.error(response?.message || "Failed to request report");
    }
  } catch (error) {
    toast.error("Error requesting report");
  }
   finally {
    setIsRequestingReport(false);
  }
};


  return (
    <>
      <ReportsTab
        loader={loader}
        handleChange={handleChange}
        value={value}
        titleData={titleData}
        rideTrackData={tableData}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        isLoadingRideAnalytic={isLoadingRideAnalytic}
        rideAnalytic={bookingData}
        onClickTableVendor={onClickTableVendor}
        isClickable = {false}
        countSrc={bookingCount}
        title={'Booking'}
        exportDataDisplay={true}
        filterDisplay = {false}
        onSelectDateRange={onSelectDateRange}
        dateFrom={dateFrom}
        dateTo={dateTo}
        tabName={'rideTrack'}
        onExport={onExport}
        onInputChange={onInputChange}
        role={role}
        userProfileData={userProfileData}
        selectCity={true}
        locValue={locValue}
        hasViewMoreIcon={hasViewMoreIcon}
        onRequestReport={onRequestReport}
        isRequestingReport={isRequestingReport}
      />
    </>
  );
}

export default Reports;




